import { useEffect, useState } from 'react';
import { getSignedChatFileUrl, SIGNED_URL_REFRESH_DELAY_MS } from '@/lib/chat/chatFiles';

/**
 * Signed URL for a chat file: `undefined` while loading, `null` if signing failed.
 * Re-signs shortly before the URL expires so long-lived chats keep working.
 */
export function useSignedChatFileUrl(path: string): string | null | undefined {
  const [url, setUrl] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    let timer: number | undefined;

    const load = async () => {
      const signedUrl = await getSignedChatFileUrl(path);
      if (cancelled) return;
      setUrl(signedUrl);
      if (signedUrl) timer = window.setTimeout(load, SIGNED_URL_REFRESH_DELAY_MS);
    };
    load();

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [path]);

  return url;
}
